import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { HOURS, SITE, TEL } from "../../lib/site";

const LINKS = [
  ["/", "Accueil"], ["/#services", "Services"], ["/remplacement-pare-brise-haguenau", "Pare-brise"], ["/vitrage-automobile-haguenau", "Vitrage"],
  ["/calibration-camera-adas-haguenau", "Calibration ADAS"], ["/renovation-optiques-phares-haguenau", "Rénovation optiques"], ["/pare-brise-domicile-haguenau", "À domicile"],
  ["/assurance-pare-brise-haguenau", "Assurances"], ["/faq", "FAQ"], ["/contact", "Contact"], ["/blog", "Blog"], ["/a-propos", "À propos"],
];

export function Footer() {
  return (
    <footer className="relative overflow-hidden bg-ag-ink pb-28 pt-20 text-slate-300 md:pb-10" data-testid="site-footer">
      <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full border border-dashed border-white/10" />
      <div className="mx-auto grid max-w-[1320px] gap-12 px-5 lg:grid-cols-[1.3fr_1fr_1fr_1fr] lg:px-8">
        <div className="space-y-5">
          <Logo light />
          <p className="max-w-xs text-sm text-slate-400">{SITE.tagline}.</p>
          <address className="space-y-2 not-italic text-sm">
            <p className="flex gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-ag-yellow" />{SITE.name}<br />{SITE.street}<br />{SITE.zip} {SITE.city}</p>
            <a href={TEL} className="flex items-center gap-2 font-semibold text-white hover:text-ag-yellow" data-testid="footer-phone-link"><Phone className="h-4 w-4 text-ag-yellow" />{SITE.phone}</a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-email-link"><Mail className="h-4 w-4 text-ag-yellow" />{SITE.email}</a>
          </address>
        </div>
        <div>
          <p className="mb-4 font-display text-sm font-bold uppercase tracking-[0.18em] text-white">Horaires</p>
          <ul className="space-y-1.5 text-sm">
            {HOURS.map((h) => <li key={h.day} className="flex justify-between gap-4"><span>{h.day}</span><span className="font-mono text-slate-200">{h.open ? `${h.open} – ${h.close}` : "Fermé"}</span></li>)}
          </ul>
        </div>
        <nav className="lg:col-span-2" aria-label="Liens du pied de page">
          <p className="mb-4 font-display text-sm font-bold uppercase tracking-[0.18em] text-white">Liens</p>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
            {LINKS.map(([to, l]) => <li key={to}><Link to={to} className="hover:text-white" data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{l}</Link></li>)}
          </ul>
        </nav>
      </div>
      <div className="mx-auto mt-14 flex max-w-[1320px] flex-col gap-3 border-t border-white/10 px-5 pt-6 text-xs text-slate-400 sm:flex-row sm:justify-between lg:px-8">
        <p>© {new Date().getFullYear()} {SITE.name} — Centre de la marque A+ Glass</p>
        <div className="flex flex-wrap gap-4">
          <Link to="/mentions-legales" className="hover:text-white" data-testid="footer-legal-link">Mentions légales</Link>
          <Link to="/politique-confidentialite" className="hover:text-white" data-testid="footer-privacy-link">Politique de confidentialité</Link>
          <Link to="/politique-confidentialite#cookies" className="hover:text-white" data-testid="footer-cookies-link">Gestion des cookies</Link>
        </div>
      </div>
    </footer>
  );
}
